export default "__VITE_ASSET__8pegrk9M__"